import BaseBridge from 'config/bridge/BaseBridge'
import { PageDirections } from 'enums/PageDirections'
import { useHistory, useLocation } from 'react-router-dom'
import { TypesRoutes } from 'routes/mixedRoutes/types'
import useBoundState from 'store'
import { Icons } from 'utils/icons'

import { AppBar } from '@interco/inter-ui/components/AppBar'

import { ContentNavbar } from './Navbar.styles'

export const Navbar = () => {
  const history = useHistory()
  const location = useLocation()

  const title = useBoundState((state) => state.title)
  const actionIcons = useBoundState((state) => state.actionIcons)
  const firstPage = useBoundState((state) => state.firstPage)
  const hideNavbar = useBoundState((state) => state.hideNavbar)
  const setPageTransitionDirection = useBoundState((state) => state.setPageTransitionDirection)
  const customBackListener = useBoundState((state) => state.customBackListener)
  const setCustomBackListener = useBoundState((state) => state.setCustomBackListener)

  const isAtFirstPage = location.pathname === firstPage

  const callAndResetCustomBackListener = () => {
    if (customBackListener) {
      customBackListener()
      setCustomBackListener(undefined)
    }
  }

  const onClickedBack = () => {
    setPageTransitionDirection(PageDirections.BACKWARD)

    if (isAtFirstPage) {
      BaseBridge.requestGoBack()
      return
    }

    customBackListener ? callAndResetCustomBackListener() : history.goBack()

    setTimeout(() => {
      setPageTransitionDirection(PageDirections.FORWARD)
    }, 550)
  }

  const renderBackBtn = (
    <Icons.ArrowLeft
      data-testid="back-button"
      color="var(--primary500)"
      width={24}
      height={24}
      onClick={onClickedBack}
    />
  )

  const renderHomeBtn = (
    <Icons.Home
      data-testid="home-button"
      color="var(--primary500)"
      width={24}
      height={24}
      onClick={() => BaseBridge.requestGoBack()}
    />
  )

  const renderFaqBtn = (
    <Icons.Help
      data-testid="faq-button"
      color="var(--primary500)"
      width={24}
      height={24}
      onClick={() => history.push(TypesRoutes.FAQ)}
    />
  )

  const renderCloseBtn = (
    <Icons.Close
      data-testid="close-button"
      color="var(--primary500)"
      width={24}
      height={24}
      onClick={() => history.push(TypesRoutes.AFTER_SALES)}
    />
  )

  const navIcons: { [actionIcons: string]: JSX.Element } = {
    HOME: renderHomeBtn,
    FAQ: renderFaqBtn,
    BACK: renderBackBtn,
    CLOSE: renderCloseBtn,
  }

  return (
    <ContentNavbar $hide={hideNavbar}>
      <AppBar
        hideLeftIcon={!actionIcons.leftIcon}
        leftIcon={actionIcons.leftIcon && navIcons[actionIcons.leftIcon]}
        rightIcon={actionIcons.rightIcon && navIcons[actionIcons.rightIcon]}
      >
        {title}
      </AppBar>
    </ContentNavbar>
  )
}
